module.exports = __webpack_public_path__ + "img/map.badeceb1.png";